module.exports = __webpack_public_path__ + "img/capsule-toy-green.b09d11e6.png";